export default __webpack_public_path__ + "static/media/664.6e198c2d.gif";